import { render } from "./Brand.vue?vue&type=template&id=2ba20528&scoped=true&ts=true"
import script from "./Brand.vue?vue&type=script&lang=ts"
export * from "./Brand.vue?vue&type=script&lang=ts"

import "./Brand.vue?vue&type=style&index=0&id=2ba20528&lang=scss&scoped=true"
import "./Brand.vue?vue&type=style&index=1&id=2ba20528&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba20528"]])

export default __exports__